import { RangeProps } from '.';
import React from 'react';
import { Input } from '../Input/Input';

// This object should contain a mock value for each required prop of this component
export const requiredProps: RangeProps = {
  children: [<Input key="0" />, <Input key="1" />],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      children: [<Input key="0" />, <Input key="1" />], // TODO this prop should be declared as required since the component explodes without it
    } as RangeProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
